import React, { useState } from 'react';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import useApiCallHooks from "../../../../hooks/useApiCallHooks";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const Addsyallbus = () => {
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    class: '',
    age: '',
    price: '',
    level: '',
    is_popular: false,
    theory: [''],
    practical: [''],
    project: ['']
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleArrayChange = (field, index, value) => {
    const updated = [...formData[field]];
    updated[index] = value;
    setFormData({ ...formData, [field]: updated });
  };

  const addArrayItem = (field) => {
    setFormData({ ...formData, [field]: [...formData[field], ''] });
  };

  const removeArrayItem = (field, index) => {
    const updated = [...formData[field]];
    updated.splice(index, 1);
    setFormData({ ...formData, [field]: updated });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const cleanedData = {
      ...formData,
      theory: formData.theory.filter(item => item.trim() !== ''),
      practical: formData.practical.filter(item => item.trim() !== ''),
      project: formData.project.filter(item => item.trim() !== '')
    };

    console.log('Submitting cleaned form data:', cleanedData);
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 3000);


      callAPI("post", "admin/robotic-syllabuses", cleanedData)
  };
 if (responce?.data && statusCode === 201) {
    toast.success("robotic-syllabuses Added Successfully!");
    setTimeout(() => {
      navigate("/robotic-syallbus/list");
    }, 2000);
  }
  return (
    <AdminAppBody 
    loading={loading}
    content={
      <div className="container card mt-4">
        <h3 className='mt-2'>Add Syllabus</h3>


        <form onSubmit={handleSubmit}>
          <div className="row">
            {/* Class */}
            <div className="mb-3 col-md-6">
              <label className="form-label fw-bold">Class</label>
              <input
                name="class"
                className="form-control"
                value={formData.class}
                onChange={handleChange}
              />
               <span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.class}
                </span>
            </div>

            {/* Age */}
            <div className="mb-3 col-md-6">
              <label className="form-label fw-bold">Age</label>
              <input
                name="age"
                className="form-control"
                value={formData.age}
                onChange={handleChange}
              
              /><span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.age}
                </span>
            </div>

            {/* Price */}
            <div className="mb-3 col-md-6">
              <label className="form-label fw-bold">Price</label>
              <input
                name="price"
                type="number"
                className="form-control"
                value={formData.price}
                onChange={handleChange}
               
              /><span className="val-message text-danger">
                  {error?.message === "ValidationError" && error?.data?.price}
                </span>

            </div>
            {/* Level Dropdown */}
            <div className="mb-3 col-md-6">
              <label className="form-label fw-bold">Level</label>
              <select
                name="level"
                className="form-select"
                value={formData.level}
                onChange={handleChange}
             
              >
                <option value="">Select level</option>
                <option value="Beginner">Beginner</option>
                <option value="Intermediate">Intermediate</option>
                <option value="Advanced">Advanced</option>
                <option value="Expert">Expert</option>
              </select>
            </div>

            {/* Is Popular */}
            <div className="mb-4 col-md-6">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  name="is_popular"
                  checked={formData.is_popular}
                  onChange={handleChange}
                  id="isPopularCheck"
                />
                <label className="form-check-label" htmlFor="isPopularCheck">
                  Is Popular
                </label>
              </div>
            </div>
          </div>

          {/* Array fields */}
          {['theory', 'practical', 'project'].map((field) => (
            <div className="mb-4" key={field}>
              <label className="form-label text-capitalize fw-bold">{field}</label>
              {formData[field].map((item, index) => (
                <div key={index} className="input-group mb-2">
                  <input
                    type="text"
                    className="form-control"
                    value={item}
                    onChange={(e) => handleArrayChange(field, index, e.target.value)}
                  />
                  {formData[field].length > 1 && (
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => removeArrayItem(field, index)}
                    >
                      Remove
                    </button>
                  )}
                </div>
              ))}
              <button
                type="button"
                className="btn btn-secondary btn-sm"
                onClick={() => addArrayItem(field)}
              >
                + Add {field}
              </button>
            </div>
          ))}

          {/* Submit Button */}
          <div className="text-end">
            <button type="submit" className="btn btn-primary mb-2"> Submit Syallbus</button>
          </div>
        </form>
      </div>
    } />
  );
};

export default Addsyallbus;
